import type { NgtAvailabilityResponseYes } from '~/components/routes/internet/isp.api';
import config from '../../config';
import { CustomerType } from '../../models/CustomerType';
import type { SingleInternetCustomerAddress } from '~/components/routes/internet/useInternetStore';

interface CustomerVerificationDetails {
  provider: string;
  token: string;
}

export interface CheckoutRequest {
  offers: string[];
  potentialCustomer: {
    firstName: string;
    lastName: string;
    email: string;
    mobilePhone: string;
    birthDate: string;
  };
  defaultAddress: {
    street: string;
    houseNo: string | undefined;
    houseNoAlpha: string | undefined;
    zip: string;
    city: string;
  };
  trackingCode: string;
  partnerAlias: string;
  isLaterActivation: boolean;
  laterActivationDate: string | undefined;
  customerType: CustomerType;
  customerVerificationDetails: CustomerVerificationDetails;

  internetServiceOrder?: {
    partnerId: number;
    installationAddress: SingleInternetCustomerAddress;
    product: {
      productTemplateId: string;
      productId: string;
      productName: string;
      productPrice: number;
    };
    availabilityInfo: NgtAvailabilityResponseYes['availabilityInfo'];
  };
}

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const checkout = async (request: CheckoutRequest): Promise<string> =>
  fetch(`${config.apiUrl}/checkout`, {
    method: 'POST',
    headers,
    body: JSON.stringify(request),
  }).then((response) => {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
